export const BANK_ACCOUNT_TYPES = [
  { id: 'checking', label: 'Conta corrente', icon: 'account_balance' },
  { id: 'credit_card', label: 'Cartão', icon: 'credit_card' },
  { id: 'investment', label: 'Investimento', icon: 'trending_up' },
];

export const BANK_ACCOUNT_TYPE_LABELS = Object.fromEntries(
  BANK_ACCOUNT_TYPES.map((t) => [t.id, t.label])
);

export function getBankAccountTypeIcon(type) {
  return BANK_ACCOUNT_TYPES.find((t) => t.id === type)?.icon || 'account_balance_wallet';
}
